var app = angular.module("leonardo");

var ExportTranslatedDialog = function ($scope, AccountUserService, AuthDataService, $http, ConfigThemeService, FilterService, NotificationService, FormErrorsService, DynamicFormRestService) {
    $scope.languages = $scope.ngDialogData.languages;
    $scope.emails = 1;
    $scope.emails_send = [];
    $scope.language = null;
    $scope.options = DynamicFormRestService.optionsForExportContent;
    if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.user) {
        $scope.emails_send.push(AccountUserService.currentAccountUser.user.email);
    } else {
        $scope.emails_send.push(AuthDataService.authData.user.email);
    }

    $scope.getNumberEmails = function () {
        return new Array($scope.emails);
    };
    $scope.addEmail = function () {
        $scope.emails++;
      };
    
    $scope.emailsError = function () {
        if (!$scope.Form.$submitted) {
          return false;
        } else if ($scope.emails_send.length === 0) {
          return true;
        } else {
          var error = true;
          angular.forEach($scope.emails_send, function (value) {
            if (value) {
              error = false;
            }
          });
          return error;
        }
      };
    
      $scope.generateUrl = function (url, filters) {
        var query = '?';
        angular.forEach(filters, function (value, key) {
          if (!isNull(value)) {
            if (angular.isArray(value)) {
              var filter = value.join(',');
              query += key + '=' + encodeURIComponent(filter) + '&';
            } else {
              query += key + '=' + ((angular.isString(value) && key != 'folder') ? encodeURIComponent(value) : value) + '&';
            }
          }
        });
        query = query.slice(0, -1);
        url += query;
        return url;
      };

    $scope.submit = function () {
        $scope.Form.$setSubmitted();
        if ($scope.emailsError()) return;
        if ($scope.Form.$invalid) {
            FormErrorsService.goToError();
            return;
        }
        $scope.filters = {};
        let selected_language = $scope.languages.filter(lang => lang.id.toString() == $scope.language).map(lang => lang.code);
        $scope.filters.response_email_recipients = $scope.emails_send.join(',');
        $scope.filters.language = selected_language;
        let url = ConfigThemeService.generateURL('/api/2.0/dynamic-forms/export/');
        url = $scope.generateUrl(url, $scope.options);
        $http.post(url, $scope.filters).then((res)=>{
            promiseResolve(res);
        });
    };
    
    function promiseResolve(res) {
        NotificationService.notify('success', res.data.message);
        $scope.closeThisDialog();
    }

};

app.controller('ExportTranslatedDialog', ['$scope', 'AccountUserService', 'AuthDataService', '$http', 'ConfigThemeService',
'FilterService', 'NotificationService', 'FormErrorsService', 'DynamicFormRestService', ExportTranslatedDialog]);
